export class ValuesValidator {
  public static validateString(value: string | null | undefined): boolean {
    return value !== null && value !== undefined && value.length > 0;
  }
}
